class AdsComponent extends HTMLElement {
  constructor() {
    super(),
      (this.adItems = this.querySelectorAll(".shopify-ads--wraper")),
      (this.currentImageIndex = 0),
      (this.rotating = this.rotating.bind(this)),
      (this.interval = 5e3),
      setInterval(this.rotating, this.interval);
  }
  rotating() {
    this.adItems.forEach((t) => {
      t.classList.remove("flip-horizontal-top");
    }),
      this.currentImageIndex < this.adItems.length - 1
        ? this.currentImageIndex++
        : (this.currentImageIndex = 0),
      this.adItems[this.currentImageIndex].classList.add("flip-horizontal-top");
    let t = (3 * this.interval) / 1e3;
    setTimeout(() => {
      this.adItems.forEach((t) => {
        t.classList.add("invisible-ad");
      }),
        this.currentImageIndex == this.adItems.length - 1
          ? this.adItems[0].classList.remove("invisible-ad")
          : this.adItems[this.currentImageIndex + 1].classList.remove(
              "invisible-ad"
            );
    }, this.interval / t);
  }
}
customElements.define("ads-component", AdsComponent);
